import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerPaymentOptions } from "@/lib/query/core/invalidation";

type DeletePaymentOptionInput = {
  storeSlug: string;
  detailId: string;
};

export function useDeletePaymentOptionMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ detailId }: DeletePaymentOptionInput) =>
      apiJsonClient<unknown>(endpoints.seller.paymentOptionById(detailId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerPaymentOptions(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
